import React from "react";
import styled from 'styled-components';

import config from "../../Config";
import PrimaryButton from "../../components/buttons/PrimaryButton";
import Storage from "../../util/Storage";
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';

const ModalContainer = styled.div`
    display: flex;
    background-color: #ffffff;
    flex-direction: column;
    padding: 10px 15px;
    border-radius: 10px;
    margin: 0px 10px;
`;

const ModalMsg = styled.div`
    padding: 1px 4px;
    margin: 4px;
    border: 1px dashed;
    display: flex;
    border-radius: 4px;
    justify-content: space-between;
`;

const ModalHeader = styled.div`
    margin-bottom: 15px;
    font-size: 16px;
`;

const CovidAlertPopup = ({count,t,hidePopup}) => {

	return <ModalContainer>		
	<div className="flex-right">
              <CloseIcon  
                style={{
		    flex:1,
		    marginLeft:221,
                    height: 30,
                    width: 30
                }}
                variant="contained"
                onClick={() => {
                    hidePopup();
                }}
            />
		</div>
            <img style={{marginLeft:5}} src={`http://games2u.net.s3.amazonaws.com/G2U/banners/epu_tip_bnw.png`}
             height="325px" width="225px" alt="bid-hammer"/>

	</ModalContainer>
}

export default CovidAlertPopup;



// WEBPACK FOOTER //
// ./src/views/Auctions/CovidAlertPopup.js